import { render, staticRenderFns } from "./NewBuilderTemplate.vue?vue&type=template&id=c831859c"
import script from "./NewBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./NewBuilderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports